import { css } from "@emotion/react";

import { COLORS } from "../stylesheets/emotion/vars";

export const priceGridStyles = css`
    .priceGrid {
        display: flex;
        gap: 4px;
        flex-wrap: wrap;
    }

    .priceCardWrapper {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 2px;
    }

    .priceLabel {
        //flex: 1;
    }

    .priceCard {
        padding: 2px 2px 2px 4px;
        border-radius: 8px;
        text-align: left;
        cursor: pointer;
        min-width: 60px;
        transition: 0.1s ease-in-out;
        display: flex;
    }

    .priceCardDisabled {
        color: ${COLORS.mediumGrey};
    }

    .priceCardHeader {
        display: flex;
        align-items: center;
        justify-content: left; /* Ensures max space between label & icon */
        gap: 5px;
        width: 100%;
    }

    .priceCard:hover {
        background-color: ${COLORS.lightestPrimary};
        box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.15);
    }

    .priceTableEditIcon {
        opacity: 0;
        transition: opacity 0.2s ease-in-out;
    }

    .priceCard:hover .priceTableEditIcon,
    .priceCardLoading .priceTableEditIcon {
        opacity: 1;
    }

    .diagonal {
        // Draw an SVG top left to bottom right
        background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' preserveAspectRatio='none' viewBox='0 0 10 10'><line x1='0' y1='0' x2='10' y2='10' stroke='%23999' stroke-width='0.5' stroke-opacity='0.3'/></svg>");
        background-position: center center;
        //scale it
        background-size: 100% 100%, auto;
    }
`;
